import { JsonRestApiRequestConfig, makeJsonRestApiRequest } from '~src/httpClient/RestApiService';

export type GetDatasourceColumnsRequestConfigParams = {
  readonly datasourceLuid: string;
}

function getDatasourceColumnsRequestConfig(params: GetDatasourceColumnsRequestConfigParams): JsonRestApiRequestConfig {
  return {
    restApiVersion: '3.25',
    httpMethod: 'GET',
    endpoint: `datasources/${params.datasourceLuid}/datasourceColumns`,
    serverWideRequest: false,
  };
}

export type GetDatasourceColumnsResponse = {
  readonly datasourceColumns: { datasourceColumn: any[] };
};

export function callGetColumnsViaApiService(params: GetDatasourceColumnsRequestConfigParams) {
    return makeJsonRestApiRequest<void, GetDatasourceColumnsResponse>({
      config: getDatasourceColumnsRequestConfig(params),
      request: null,
    });
}
